export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 lg:order-1 relative rounded-xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20secure%20online%20shopping%20concept%20with%20credit%20card%20padlock%20and%20shield%20icon%20on%20warm%20cream%20background%2C%20soft%20neutral%20tones%2C%20clean%20editorial%20photography%2C%20trust%20and%20security%20aesthetic%20for%20ecommerce&width=800&height=600&seq=safety-img-2026&orientation=landscape&nocache=true"
              alt="Safety Guide"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-sm font-semibold text-accent-600 tracking-wider uppercase">Safety</span>
            <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
              AllChinaBuy Safety Guide
            </h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              Buying through international marketplaces requires careful research. Learn how to verify sellers, review QC information, protect account details, understand shipping risks and recognize suspicious offers.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="/safety/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-white font-medium rounded-lg hover:bg-accent-600 transition-colors"
              >
                Read the AllChinaBuy Safety Guide
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="/allchinabuy-legit/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-700 font-medium rounded-lg border border-background-200 hover:border-accent-300 transition-colors"
              >
                AllChinaBuy Legit
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}